// import jQuery
import './common/jquery-global';
//import './common/fotorama';
// import debug
// import debug from 'bows';

// import header
//import header from './_header.js'

var $ = jQuery.noConflict();
jQuery(document).ready(function ($) {
    headerScripts();
    //slider();
    multiSelectFilters();
    getFilterParams();
    setStatusForNoproject();
});

function headerScripts() {
    $(".header__search-btn").click(function () {
        debugger;
        $(".header__search-btn").toggle();
        $(".header-search__block").toggleClass("open");
    });
    $(".header-search__close-popup").click(function () {
        $(".header__search-btn").toggle();
        $(".header-search__block").removeClass("open");
    });
    $(".header__burger").click(function () {
        $("body").toggleClass("menu-open");
        $(".header__mobile").toggleClass("open");
        $(".header__burger").toggleClass("open-burger");
    });
    $(".header-search__icon-popup-btn").click(function () {
        $(".search-form--header").submit();
    });
    $(".mobile-search__icon-popup-btn").click(function () {
        $(".mobile-search__form").submit();
    });
    $(".search-form__submit").click(function () {
        $(".search-form--search-page").submit();
    });
    $(".search-form__reset").on("click", function(event) {
        $(".search-form-search-page__input").val("");
    });
    $(".map-type").click(function () {
            $(".list-type").addClass("active");
            $(".map-type").removeClass("active");
            $(".tab-map").removeClass("active");
            $(".tab-list").addClass("active");
        });
        $(".list-type").click(function () {
            $(".map-type").addClass("active");
            $(".list-type").removeClass("active");
            $(".tab-map").addClass("active");
            $(".tab-list").removeClass("active");
        });
};


// var cursor = document.querySelector('.cursor');
// var cursorinner = document.querySelector('.cursor2');
// var a = document.querySelectorAll('a');
//
// document.addEventListener('mousemove', function(e){
//   var x = e.clientX;
//   var y = e.clientY;
//   cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`
// });

// document.addEventListener('mousemove', function(e){
//   var x = e.clientX;
//   var y = e.clientY;
//   cursorinner.style.left = x + 'px';
//   cursorinner.style.top = y + 'px';
// });
//
// document.addEventListener('mousedown', function(){
//   cursor.classList.add('click');
//   cursorinner.classList.add('cursorinnerhover')
// });
//
// document.addEventListener('mouseup', function(){
//   cursor.classList.remove('click')
//   cursorinner.classList.remove('cursorinnerhover')
// });
//
// a.forEach(item => {
//   item.addEventListener('mouseover', () => {
//     cursor.classList.add('hover');
//   });
//   item.addEventListener('mouseleave', () => {
//     cursor.classList.remove('hover');
//   });
// })

// function slider() {
//     (function ($) {
//     const galleries = $('.blocks-gallery-grid');
//                         galleries.each(function () {
//                             var $fotoramaDiv = $(this).fotorama()
//                             var fotorama = $fotoramaDiv.data('fotorama');
//                             fotorama.resize({
//                                 width: '100%',
//                                 height: 'auto'
//                             });
//                             console.log(fotorama);
//         });
//     })(jQuery)
// };


function multiSelectFilters() {
    let btn = $('.toggle__header');
    let list = $('.toggle__list');
    let listItems = $('.incidents-select__link');

    if (btn.length) {
        btn.each(function (i) {
        var $thisBtn = $( this );
            $thisBtn.click(function () {

            list.each(function(j) {
            if(j ==! i){
                $(this).removeClass('show');
                }
            });

            $thisBtn.toggleClass('active');

            let $current = $( list[i] );
            $current.toggleClass('show');
            });
        })
        $(document).click(function (e) {
            if (list.hasClass('show') && !btn.is(e.target) && btn.has(e.target).length === 0 && !list.is(e.target) && list.has(e.target).length === 0) {
                btn.each(function () {
                    $(this).removeClass('active');
                });
                list.each(function () {
                    $(this).removeClass('show');
                });
            }
        });

        $('.filter-reset').click(function () {
            $('.filters__link').removeClass('checked');
            btn.each(function () {
                $(this).removeClass('active');
            });
            list.each(function () {
                $(this).toggleClass('show');
            });
            $('.activity-select__checked').html($('.activity-select__checked').data('text-default'));
            $('.activity-select__checked').removeClass('active');
            $('.projects-select__checked').html($('.projects-select__checked').data('text-default'));
            $('.projects-select__checked').removeClass('active');
            $(this).removeClass('active');
            getFiltersPosts();


            $('.project__link').each( function() {
                 $(this).removeClass('hide');
            });
            $('.project__link-noproject').addClass('hide');
            setStatusForNoproject();

        });
    }
    $('.filters__link').click(function () {
        $('.filter-reset').addClass('active');
        btn.each(function () {
           $(this).removeClass('active');
        });
        $('.filters__link').each( function() {
            $(this).removeClass('hide');
        }).removeClass('checked');

        $(this).toggleClass('checked');
        list.each(function () {
            $(this).removeClass('show');
        });
        let filterParams = getFilterParams();

        if(filterParams['activityName'].length > 0 ){
            $('.activity-select__checked').html(filterParams.activityName.join('/'));
            $('.activity-select__checked').addClass('active');
        } else {
            $('.activity-select__checked').html($('.activity-select__checked').data('text-default'));
            $('.activity-select__checked').removeClass('active');
        }
        if(filterParams['projectName'].length > 0 ){
            $('.projects-select__checked').html(filterParams.projectName.join('/'));
            $('.projects-select__checked').addClass('active');
        } else {
            $('.projects-select__checked').html($('.projects-select__checked').data('text-default'));
            $('.projects-select__checked').removeClass('active');
        }

        getFiltersPosts();
    });
}

function getFiltersPosts() {

    let param = '';
    let parameters = '';
    let filterParams = getFilterParams();
    let lang = $('.filter-block').data('lang');
    let postType = $('.activity-select__wrap').data('type');
    let activity = $('.activity__link').data('activity-slug');
    let projects = $('.project__link').data('project-slug');

    if (filterParams['activity'].length && filterParams['activity'] !== 'all') {
        param += '&activity=' + filterParams['activity'];
    }

    if (filterParams['projects'].length && filterParams['projects'] !== 'all') {
        param += '&project=' + filterParams['projects'];
    }

    if (param.length) {
        parameters = '?' + param.slice(1);
    }

    history.pushState('', '', window.location.origin + '/' + lang + '/' + postType + '/' + parameters);


    var data = {
        'action': 'posts_filters',
        'postType': postType,
        'activity': filterParams['activity'],
        'projects': filterParams['projects'],
        'urlParam': parameters
    };

    $.ajax({
        url: ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
            $('.loader-wrap').removeClass('hide');
        },
        complete: function () {
            $('.loader-wrap').addClass('hide');
        },
        success: function (data) {
            let res = JSON.parse(data);
            if (res.posts !== '') {
                $('.base-wrap').html(res.posts);
            }
            $('.pagination').html(res.pagination);
        }
    });
}

function getFilterParams() {
    let filterParam = [];
    filterParam['activity'] = [];
    filterParam['projects'] = [];
    filterParam['activityName'] = [];
    filterParam['projectName'] = [];
    filterParam['projects_of_activities'] = [];
    $('.checked').each(function () {
        if ($(this).data('activity')) {
            filterParam['activity'].push($(this).data('activity'));
            filterParam['activityName'].push($(this).text());
            if ( $(this).data('projectsOfActivity') ) {
                filterParam['projects_of_activities'].push($(this).data('projectsOfActivity'));
            }
        }
        if ($(this).data('project')) {
            filterParam['projects'].push($(this).data('project'));
            filterParam['projectName'].push($(this).text());
        }
    });
    if(filterParam['activity'][0]){
        setListOfProjects(filterParam['projects_of_activities']);
    }

    return filterParam;
};

function setListOfProjects(activities) {
    let result = [];
    let set = new Set();
    if(activities){
        activities.forEach((element) => {
            result.push( element.toString().split(',') );
        });
        for (let arr of result){
            arr.map( ( value ) => set.add( value ) );
        }
        result = [...set];

        $('.project__link').each( function() {
            if ( result && !result.includes( $(this).data('project').toString() ) ) {
                $(this).addClass('hide');
            } else {
                $(this).removeClass('hide');
            }
        });
    }
        setStatusForNoproject();

};
function setStatusForNoproject(){
    if( $('.project__link.filters__link.hide').length !== $('.project__link.filters__link').length ) {
           $('.project__link-noproject').addClass('hide');
        } else {
            $('.project__link-noproject').removeClass('hide');
    }
}


jQuery(document).ready(function ($) {
	function set_mobile() {
		jQuery("body").removeClass("glossary-mobile");
		jQuery(".glossary-tooltip-content-mobile").toggleClass(
			"glossary-tooltip-content glossary-tooltip-content-mobile"
		);
		jQuery(".glossary-tooltip-text-mobile").toggleClass(
			"glossary-tooltip-text glossary-tooltip-text-mobile"
		);

		if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
            if (navigator.maxTouchPoints > 0) {
              set_classes();
            }
          } else {
            if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
                set_classes();
            } else if (window.TouchEvent || ('ontouchstart' in window)) {
                set_classes();
            }
        }

		function set_classes() {
		    jQuery("body").addClass("glossary-mobile");
        			jQuery(".glossary-tooltip-content").toggleClass(
        				"glossary-tooltip-content glossary-tooltip-content-mobile"
        			);
        			jQuery(".glossary-tooltip-text").toggleClass(
        				"glossary-tooltip-text glossary-tooltip-text-mobile"
        			);
        			if (
        				jQuery(".glossary-tooltip-content-mobile").children("svg.close")
        					.length === 0
        			) {
        				if (jQuery("body.is-rtl").length === 0) {
        					jQuery(".glossary-tooltip-content-mobile").prepend(
        						'<svg class="close" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.53929 1.03929L19.9999 18.4999L17.4606 18.9606L6.49981e-06 1.49999L2.53929 1.03929Z" fill="white"/><path d="M1.03929 17.4607L18.4999 8.1513e-05L18.9606 2.53937L1.49999 20L1.03929 17.4607Z" fill="white"/></svg>');
        				} else {
        					jQuery(".glossary-tooltip-content-mobile").append(
        						'<svg class="close" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.53929 1.03929L19.9999 18.4999L17.4606 18.9606L6.49981e-06 1.49999L2.53929 1.03929Z" fill="white"/><path d="M1.03929 17.4607L18.4999 8.1513e-05L18.9606 2.53937L1.49999 20L1.03929 17.4607Z" fill="white"/></svg>'
        					);
        				}
        			}
        		}
	}
	set_mobile();
	jQuery( window ).on('resize', function () {
		set_mobile();
	});
	jQuery(".glossary-mobile").on(
		"click",
		".glossary-link a, .glossary-link span",
		function (e) {
			jQuery(this)
				.parent()
				.parent()
				.find(".glossary-tooltip-content-mobile")
				.toggleClass("glossary-show-tooltip")
			e.preventDefault();

		}
	);

	jQuery(".glossary-mobile").on(
		"click",
		".glossary-tooltip-content-mobile",
		function (e) {
			//jQuery(this).parent().find(".glossary-link a").click;
			document.location.href = $(this).parent().find(".glossary-link a").attr('href');
		}
	);

	jQuery(".glossary-mobile").on(
    		"click",
    		".glossary-tooltip-content-mobile .close",
    		function (e) {
    			jQuery(this).parent().toggleClass("glossary-show-tooltip");
    			e.preventDefault();
    			e.stopPropagation()
    		}
    	);
});